import React from 'react';
import ReactDOM from 'react-dom/client';
import Redirect from './redirect';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Redirect />
  </React.StrictMode>
); 